import {Grid, SectionIntroStacked} from '@primer/react-brand/esm'
import {getPrimerIcon} from '@github-ui/swp-core/lib/utils/icons'
import {renderWithoutParagraphs} from '../../../../utils'
import type {IntroSectionProps} from '../types'

type Props = Pick<IntroSectionProps, 'introContextHeading' | 'introContextBody' | 'introContextLink' | 'introItems'> & {
  promoteFirstHeading?: boolean
}

export function IntroSimpleIntro({
  introContextHeading,
  introContextBody,
  introContextLink,
  introItems,
  promoteFirstHeading = false,
}: Props) {
  if (!introContextHeading && !introContextBody) return null

  const firstIntroItemHeadingIndex = introItems?.findIndex(item => Boolean(item.fields.heading)) ?? -1

  return (
    <Grid enableGutters={false}>
      <Grid.Column>
        <SectionIntroStacked variant="gridline">
          {introContextHeading ? (
            <SectionIntroStacked.Heading size="5">
              {renderWithoutParagraphs(introContextHeading)}
            </SectionIntroStacked.Heading>
          ) : null}
          {introContextBody ? (
            <SectionIntroStacked.Description>
              {renderWithoutParagraphs(introContextBody)}
            </SectionIntroStacked.Description>
          ) : null}
          {introContextLink?.fields.href && (
            <SectionIntroStacked.Link href={introContextLink.fields.href}>
              {introContextLink.fields.text}
            </SectionIntroStacked.Link>
          )}
          {introItems && introItems.length > 0 ? (
            <SectionIntroStacked.Items>
              {introItems.map((item, index) => {
                const isIconItem = item.sys.contentType.sys.id === 'iconItem'
                const IconComponent = isIconItem && 'icon' in item.fields ? getPrimerIcon(item.fields.icon) : null
                return (
                  <SectionIntroStacked.Item key={item.sys.id}>
                    {IconComponent ? <SectionIntroStacked.ItemIcon icon={<IconComponent />} size={'medium'} /> : null}
                    {item.fields.heading ? (
                      <SectionIntroStacked.ItemHeading
                        as={index === firstIntroItemHeadingIndex && promoteFirstHeading ? 'h2' : 'h3'}
                        size="subhead-large"
                      >
                        {renderWithoutParagraphs(item.fields.heading)}
                      </SectionIntroStacked.ItemHeading>
                    ) : null}
                    {item.fields.description ? (
                      <SectionIntroStacked.ItemDescription>
                        {renderWithoutParagraphs(item.fields.description)}
                      </SectionIntroStacked.ItemDescription>
                    ) : null}
                  </SectionIntroStacked.Item>
                )
              })}
            </SectionIntroStacked.Items>
          ) : null}
        </SectionIntroStacked>
      </Grid.Column>
    </Grid>
  )
}
